module.exports = __webpack_public_path__ + "img/forget-passwordEN.f8eba431.png";